<template>
  <div class="home">
    <div class="home-page-wrapper banner-wrapper" id="banner">
      <div class="banner-bg-wrapper">
        <div class="banner-bg">
          <img src="../assets/img/home-bg.jpg" />
        </div>
        <div class="banner-bg-hider"></div>
      </div>
      <div class="banner page">
        <div class="text-wrapper" style="opacity: 1;">
          <h1 class="">Do This With Me</h1>
          <p class=""><span>Keep track of the things you want to do with the people in your life.</span></p>
          <div class="banner-btns">
            <a class="banner-btn components" href="#"><span>Sign Up</span></a>
            <a class="banner-btn language" href="#"><span>Explore Events</span></a>
          </div>
        </div>
      </div>
    </div>
    <div class="home-page-wrapper page1">
      <div class="page">
        <h2><span>Your
            <WordSwitcher :words="['Calendar', 'Event Finder', 'Group Chat', 'Meetup Page']" />.</span></h2>
        <div>
          <div class="ant-row">
            <div class="ant-col-xs-24 ant-col-md-6">
              <svg class="page1-point-wrapper" width="213px" height="303px" viewBox="0 0 213 303" stroke="none"
                stroke-width="1" fill="none" fill-rule="evenodd"></svg>
              <a class="page1-block" href="#">
                <div class="page1-image">
                  <v-icon scale="2" name="calendar-plus" />
                </div>
                <h3>Create</h3>
              </a></div>
            <div class="ant-col-xs-24 ant-col-md-6">
              <svg class="page1-point-wrapper" width="207px" height="295px" viewBox="0 0 207 295" stroke="none"
                stroke-width="1" fill="none" fill-rule="evenodd"></svg>
              <a class="page1-block" href="#">
                <div class="page1-image">
                  <v-icon scale="2" name="search-location" />
                </div>
                <h3>Explore</h3>
              </a>
            </div>
            <div class="ant-col-xs-24 ant-col-md-6">
              <svg class="page1-point-wrapper" width="215px" height="286px" viewBox="0 0 215 286" stroke="none"
                stroke-width="1" fill="none" fill-rule="evenodd" style="transform: translateX(-30px);"></svg>
              <a class="page1-block" href="#">
                <div class="page1-image">
                  <v-icon scale="2" name="share-square" />
                </div>
                <h3>Invite</h3>
              </a></div>
            <div class="ant-col-xs-24 ant-col-md-6">
              <svg class="page1-point-wrapper" width="193px" height="286px" viewBox="0 0 193 286" stroke="none"
                stroke-width="1" fill="none" fill-rule="evenodd" style="transform: translateY(-20px);"></svg>
              <a class="page1-block" href="#">
                <div class="page1-image">
                  <v-icon scale="2" name="infinity" />
                </div>
                <h3>Do More</h3>
              </a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WordSwitcher from "@/components/WordSwitcher.vue";

export default {
  name: "home",
  components: {
    WordSwitcher
  }
};
</script>
